<template>
    <div style="width: 350px" v-loading="isLoading">
        <div>
            <div v-if="currentRow" style="border: 1px solid #CAD2DA;padding: 5px;border-radius: 0.3rem; position: relative;">
                <i @click="clear" style="position: absolute; right: 0; color: rgb(202, 210, 218);padding: 6px;top: 0;" class="fas fa-times cursor-pointer"></i>
                <div @click="showSelect" style="line-height: 1" class="text-muted small cursor-pointer">{{ currentRow.category_name }}</div>
                <div @click="showSelect" style="line-height: 1" class="cursor-pointer">{{currentRow.name}}</div>
                <div @click="showSelect" class="text-muted small d-flex justify-content-between cursor-pointer">
                    <div class="">{{currentRow.company.name}}</div>
                    <div class=""><span v-if="currentRow.sale_amount > 0">Продажа:{{ (currentRow.sale_amount / 100) | formatNumber }}</span> КВ: {{ currentRow.fee_percent }}%</div>
                </div>
            </div>
            <div v-if="!currentRow" style="border: 1px solid #CAD2DA;padding: 5px;border-radius: 0.3rem; position: relative;">
                <button type="button"  @click="showSelect" class="btn btn-link btn-sm btn-block py-0"><span>Выбрать продукт</span></button>
            </div>
        </div>
        <el-dialog :title="'Выбор продукта'" :visible.sync="visibleModalModel" width="350px" :append-to-body="true">
            <el-row class="mb-4" :gutter="5">
                <el-col :span="24" class="mb-1">
                    <Select2 placeholder="Площадка" v-model="platform_id" :options="platform_select" :id="'platform_id' + _uid" :settings="{width: '100%'}"/>
                    <div v-if="!platform_id" class="invalid-feedback d-block" v-html="'Выберите площадку!'" />
                </el-col>
                <el-col :span="24" class="mb-1">
                    <input type="text" class="form-control" v-model="name" placeholder="Название" clearable />
                </el-col>
                <el-col :span="24" class="mb-1">
                    <Select2 placeholder="Категория" v-model="category_name" :options="categories_select" :id="'category_name' + _uid" :settings="{width: '100%', allowClear: true}"/>
                </el-col>
                <el-col :span="24" class="mb-1">
                    <Select2 placeholder="Юр лицо" v-model="company" :options="company_select" :id="'company' + _uid" :settings="{width: '100%', allowClear: true}"/>
                </el-col>
            </el-row>
            <el-table
                ref="affiliateProgramsTable"
                :show-header="false"
                :data="affiliate_programs_filtered"
                highlight-current-row
                @current-change="handleCurrentChange"
                max-height="400"
                style="width: 100%">
                <el-table-column>
                    <template slot-scope="scope">
                        <div class="cursor-pointer">
                            <div style="line-height: 1" class="text-muted small">{{ scope.row.category_name }}</div>
                            <div style="line-height: 1">{{scope.row.name}}</div>
                            <div class="text-muted small d-flex justify-content-between">
                                <div class="">{{scope.row.company.name}}</div>
                                <div class=""><span v-if="scope.row.sale_amount > 0">Продажа:{{ (scope.row.sale_amount / 100) | formatNumber }}</span> КВ: {{ scope.row.fee_percent }}%</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "AffiliateProgramSelect",
    props: ['value', 'filter'],
    data() {
        return {
            isLoading: false,
            currentRow: null,
            visibleModalModel: false,
            affiliate_programs: [],
            platform_id: null,
            name: null,
            category_name: null,
            company: null,
        }
    },
    mounted() {
        this.fetch();
        if (this.platform_select.length === 1) {
            this.platform_id = this.platform_select[0].id;
        }
        if (this.filter) {
            if (this.filter.platform_id) this.platform_id = this.filter.platform_id;
        }
    },
    watch: {
        currentRow(val) {
            this.$emit('input', val ? val.id : null);
            this.$emit('change', val);
        },
        value(val) {
            this.setCurrentRowFromValue();
            // if (this.init_value && this.init_value.id === this.value) this.legal_owner = this.init_value;
        },
    },
    methods: {
        fetch() {
            let self = this;
            this.isLoading = true;
            axios.get('/api/affiliate_programs')
                .then(function (response) {
                    self.affiliate_programs = response.data;
                    self.isLoading = false;
                    self.setCurrentRowFromValue();
                });
        },
        showSelect() {
            this.visibleModalModel = true;
            setTimeout(() => {
                this.$refs.affiliateProgramsTable.setCurrentRow(this.currentRow);
            }, 300);
        },
        clear() {
            if (this.$refs.affiliateProgramsTable) this.$refs.affiliateProgramsTable.setCurrentRow();
            this.currentRow = null;
            this.visibleModalModel = false;
        },
        handleCurrentChange(val, old) {
            if (val && !_.isEqual(this.currentRow, val)) {
                this.currentRow = val;
                this.visibleModalModel = false;
            }
        },
        setCurrentRowFromValue() {
            if (this.value === null) {
                this.clear();
            } else {
                let row = _.find(this.affiliate_programs, {id: this.value});
                if (row) {
                    this.currentRow = row;
                }
            }
        }
    },
    computed:{
        platform_select () {
            let select = [];
            this.$store.getters['auth/user'].allowed_platforms.forEach(function (item) {select.push({id: item.id, text: item.name,})});
            select = _.sortBy(select, ['text']);
            return select;
        },
        company_select() {
            let self = this;
            return _.uniq(this.affiliate_programs.filter(p => {
                if (self.platform_id) {
                    return +p.platform_id === +this.platform_id && +p.status === 1
                } else {
                    return +p.status === 1
                }
            }).map(i => i.company.name))
        },
        affiliate_programs_filtered() {
            let affiliate_programs = this.affiliate_programs;
            affiliate_programs = affiliate_programs.filter(u => u.status === 1);
            if (!this.platform_id) return [];
            if (this.platform_id) affiliate_programs = affiliate_programs.filter(u => +u.platform_id === +this.platform_id);
            if (this.name && this.name.length >= 3) affiliate_programs = affiliate_programs.filter(u => u.name.toLowerCase().indexOf(this.name.toLowerCase()) !== -1);
            if (this.category_name && this.category_name.length >= 3) affiliate_programs = affiliate_programs.filter(u => u.category_name.toLowerCase().indexOf(this.category_name.toLowerCase()) !== -1);
            if (this.company && this.company.length >= 3) affiliate_programs = affiliate_programs.filter(u => u.company.name.toLowerCase().indexOf(this.company.toLowerCase()) !== -1);
            return affiliate_programs;
        },
        categories_select() {
            if (this.platform_id) {
                let list = this.affiliate_programs.filter(p => {
                    return +p.platform_id === +this.platform_id && +p.status === 1
                })
                    .map(p => {
                        return p.category_name;
                    });
                list = _.uniq(list);
                return list;
            } else {
                return this.categories;
            }
        },
        ...mapGetters({
            categories: "affiliate_program_categories/all",
        }),
    }
}
</script>

<style scoped>

</style>
